<template>
  <div>
    <div>
      <div class="smart-main-search-container flex flex-wrap">
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.meterNo" placeholder="请输入电表号"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>
        </div>

        <div class="w-180 mr-10">

          <date-picker v-model="searchParams.month"  format="yyyy-MM"  value-format="yyyyMM" type = "month" placeholder="请选择开始时间"></date-picker>
        </div>

        <div class="flex-1"></div>
        <div class="flex">
          <load-button @on-click="search"></load-button>
        </div>
        <div class="flex">
          <el-button type="primary" @click="exportE" plain>导出数据</el-button>
        </div>
      </div>
    </div>
    <div class="content mt-20">
      <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
    </div>

    <div class="flex flex-right mt-20">
      <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
    </div>
  </div>
</template>
<script>
  import LoadButton from "../../components/LoadButton";
  import Pagination from "../../components/Pagination";
  import SmartTable from "../../components/SmartTable";
  import FormDialog from "../../components/FormDialog";
  import UploadImg from "../../components/UploadImg";
  import Dropdown from "../../components/Dropdown";
  import DatePicker from "../../components/DatePicker";
  export default{
    components: {
      DatePicker,
      Dropdown,
      UploadImg,
      FormDialog,
      SmartTable,
      Pagination,
      LoadButton
    },
    data(){
      return {
        searchParams: {
          page: 1
        },
        searchData: {},
        opt: [
        ],
        labels: [

          {prop: 'readingTime', label: '结算月'},
            // {prop: 'createAt', label: '结算时间'},
          {prop: 'userName', label: '用户'},
            {prop: 'meterNo', label: '表号'},
            {prop: 'conNo', label: '集中器号'},
            {prop: 'totalNum', label: '用电量'},
            {prop: 'totalConsume', label: '用电金额'},



          // {prop: 'conNo', label: '中继器号'},
        ],
        temp:{}
      }
    },
    mounted(){
      this.getList()
    },
    methods: {
      search(stop){
        this.searchParams.page = 1
        this.getList(stop)
      },
      toPage(page){
        this.searchParams.page = page
        this.getList()
      },
        exportE(){

          let url =  this.globalData.host+ "/smartMeter/export/monthAcountTab?accessToken="+this.$store.state.LoginUser.accessToken||"";
          // var isFirst = true;
          for (var i in this.searchParams){
            url += "&";
            url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
          }
          this.$http$({method: 'get', url: url}, () => {
            this.$router.push('/admin/downLoadTask')

          })
        },
      getList(callback){
        if(this.$store.state.LoginUser.gardenId){
          this.searchParams.gardenID = this.$store.state.LoginUser.gardenId
        }
        this.$http$({method: 'get', url: "/smartMeter/accountTab/month",data:this.searchParams,  load: 1}, (data) => {
          callback ? callback() : ''
          this.searchData = data
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/MonthElectric.vue